import { CloudArrowUp } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import { AttributeStatus } from 'companySettings/enums';
import { usePartFinderFamilyActions } from 'companySettings/hooks';
import { IPartFinderFamily } from 'companySettings/types';
import { Button } from 'core/components';
import { NotificationPosition } from 'core/enums';
import { useAgGridClientTableContext } from 'core/states';
import { Color, Variant } from 'theme/enums';

// Publishes the drafts of the selected families. The ones already published have nothing to
// publish, and a draft with no parts cannot be: one of those would roll back the whole batch.
export const PublishPartFinderFamiliesButton = () => {
  const { t } = useTranslation();

  const { selectedRows } = useAgGridClientTableContext();
  const { publishPartFinderFamilies } = usePartFinderFamilyActions(NotificationPosition.TOP);

  const unpublishedIds = ((selectedRows ?? []) as IPartFinderFamily[])
    .filter((row) => AttributeStatus.PUBLISHED !== row.status && row.partsCount > 0)
    .map((row) => row.id);

  return (
    <Button
      text={t('buttonLabelPublish')}
      variant={Variant.SOFT}
      color={Color.PRIMARY}
      startDecorator={<CloudArrowUp />}
      disabled={!unpublishedIds.length}
      onClick={() => publishPartFinderFamilies(unpublishedIds)}
    />
  );
};
